import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { merge, Observable, Subject } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

import { NgClass } from '@angular/common';
import { AppleCommandProgressService } from '../../../../shared/services/apple-command-progress.service';
import { AppleMdmService } from '../../../../shared/services/apple-mdm-service';
import { CommandSpinnerComponent } from '../../../../utilities/command-spinner/command-spinner.component';
import { CommandProgress } from '../../../../viewmodels/apple/signalr/command-context.model';

@Component({
  selector: 'ml-mdm-clear-passcode',
  templateUrl: './clear-passcode.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommandSpinnerComponent, NgClass],
})
export class ClearPasscodeComponent {
  readonly class = input.required<string>();

  readonly udid = input.required<string>();
  private _commandProgress: Subject<CommandProgress> = new Subject<CommandProgress>();
  readonly commandProgress$: Observable<CommandProgress> = toObservable(this.udid).pipe(
    switchMap((_udid) =>
      merge(this._commandProgress, this.commandProgressService.commandsOfRequestType(_udid, 'ClearPasscode'))
    )
  );

  private readonly appleMdmService = inject(AppleMdmService);
  private readonly commandProgressService = inject(AppleCommandProgressService);

  enabled = true;

  clearPasscode() {
    this.enabled = false;

    const command: CommandProgress = {
      udid: this.udid(),
      commandUUID: '',
      status: 'Sending',
      requestType: 'DeviceLock',
    };
    this._commandProgress.next(command);

    this.appleMdmService
      .clearPasscode(this.udid())
      .pipe(
        finalize(() => {
          this.enabled = true;
        })
      )
      .subscribe();
  }
}
